class CustomersAlsoBought {

  constructor() {

    this.section = document.querySelector('.customers-also-bought');

    if (!this.section) return;

    this.cards = this.section.querySelectorAll('.cab-card');

    this.totalPrice = this.section.querySelector('.cab-total-price');

    this.addAllButton = this.section.querySelector('.cab-add-all');

    this.moneyFormat = window.Shopify?.money_format || "${{amount}}";

    this.init();

  }

  init() {

    this.cards.forEach(card => {

      this.initVariants(card);

      this.initCheckbox(card);

    });

    if (this.addAllButton) {

      this.addAllButton.addEventListener(
        'click',
        this.addAllProducts.bind(this)
      );

    }

    this.calculateTotal();

  }

  initVariants(card) {

    const selectors = card.querySelectorAll('.cab-option-select');

    if (!selectors.length) return;

    selectors.forEach(select => {

      select.addEventListener('change', () => {

        this.updateVariant(card);

      });

    });

  }

  updateVariant(card) {

    const variants = JSON.parse(

      card.querySelector('.cab-product-json').textContent

    );

    const selectedOptions = [];

    card.querySelectorAll('.cab-option-select').forEach(select => {

      selectedOptions.push(select.value);

    });

    let matchedVariant = variants.find(variant => {

      return variant.options.every((option, index) => {

        return option === selectedOptions[index];

      });

    });

    if (!matchedVariant) return;

    card.querySelector('.cab-variant-id').value = matchedVariant.id;

    const price = card.querySelector('.cab-price');

    if (price) {

      price.innerHTML = Shopify.formatMoney(

        matchedVariant.price,

        this.moneyFormat

      );

    }

    const compare = card.querySelector('.cab-compare-price');

    if (compare) {

      if (matchedVariant.compare_at_price > matchedVariant.price) {

        compare.style.display = '';

        compare.innerHTML = Shopify.formatMoney(

          matchedVariant.compare_at_price,

          this.moneyFormat

        );

      } else {

        compare.style.display = 'none';

      }

    }

    const image = card.querySelector('.cab-product-image');

    if (image && matchedVariant.featured_image) {

      image.src = matchedVariant.featured_image.src;

    }

    const button = card.querySelector('.product-form__submit');

    if (button) {

      button.disabled = !matchedVariant.available;

      button.querySelector('span').textContent = matchedVariant.available
        ? 'Add to cart'
        : 'Sold out';

    }

    this.calculateTotal();

  }

  initCheckbox(card) {

    const checkbox = card.querySelector('.cab-select-product');

    if (!checkbox) return;

    checkbox.addEventListener('change', () => {

      this.calculateTotal();

    });

  }

  calculateTotal() {

    let total = 0;

    this.cards.forEach(card => {

      const checkbox = card.querySelector('.cab-select-product');

      if (checkbox && !checkbox.checked) return;

      const variantId = Number(

        card.querySelector('.cab-variant-id').value

      );

      const variants = JSON.parse(

        card.querySelector('.cab-product-json').textContent

      );

      const variant = variants.find(v => v.id === variantId);

      if (!variant) return;

      total += variant.price;

    });

    if (this.totalPrice) {

      this.totalPrice.innerHTML = Shopify.formatMoney(

        total,

        this.moneyFormat

      );

    }

  }

    async addAllProducts() {

    const items = [];

    this.cards.forEach(card => {

      const checkbox = card.querySelector('.cab-select-product');

      // Current product has no checkbox
      if (checkbox && !checkbox.checked) return;

      const id = Number(
        card.querySelector('.cab-variant-id').value
      );

      if (id) {
        items.push({
          id: id,
          quantity: 1
        });
      }

    });

    if (!items.length) return;

    this.addAllButton.classList.add('loading');
    this.addAllButton.disabled = true;

    try {

      const body = {
        items: items
      };

      // Support Refresh/Dawn cart drawer
      const cart =
        document.querySelector('cart-drawer') ||
        document.querySelector('cart-notification');

      if (cart) {
        body.sections = cart
          .getSectionsToRender()
          .map(section => section.id);

        body.sections_url = window.location.pathname;
      }

      const response = await fetch(
        window.routes.cart_add_url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(body)
        }
      );

      const result = await response.json();

      if (result.status) {
        alert(result.description || "Unable to add products.");
        return;
      }

      if (cart) {
        cart.renderContents(result);
      } else {
        window.location.href = window.routes.cart_url;
      }

    } catch (error) {

      console.error("Customers Also Bought:", error);

      alert("Something went wrong.");

    } finally {

      this.addAllButton.classList.remove("loading");
      this.addAllButton.disabled = false;

    }

  }

}

document.addEventListener("DOMContentLoaded", () => {

  new CustomersAlsoBought();

});